import axios from 'axios'
import store from '@/store'
import router from '@/router'
import NProgress from 'nprogress'
import Vue from 'vue'

var client = axios.create({
  baseURL: (window.location.hostname == 'old.queota.club') ? 'https://api.queota.club' : 'http://localhost:5000',
  headers: {
    'Content-Type': 'application/json'
  }
})
const token = localStorage.getItem('token')
if (token) {
  client.defaults.headers.common['Authorization'] = token
}

client.interceptors.request.use(config => {
  NProgress.start()
  return config
})

client.interceptors.response.use(response => {
  NProgress.done()
  return Promise.resolve(response)
}, error => {
  if (error && error.response && error.response.status && error.response.status === 401) {
    store.dispatch('redirectingToLogin')
    router.push({ name: 'Login', query: { returnUrl: router.app.$route.path } })

  } else if (error && error.response && error.response.data && error.response.data.error) {
    Vue.notify({
      group: 'all',
      type: 'warn',
      title: error.response.data.error
    })
  }
  NProgress.done()
  return Promise.reject(error)
});
export default client
